import axios from "axios";
import { EndpointsConstants } from "../../components/Constants";
import { BE_URL } from "../urlUtils";
import { getOrCreateStickySessionId } from "../stickySessionIdManager";

export async function verifyToken(accessToken) {
  const stickySessionId = await getOrCreateStickySessionId();
  const myParams = {
    "x-sticky-session-id": stickySessionId,
  };
  const json = await axios.post(
    BE_URL + EndpointsConstants.VERIFY_TOKEN_ENDPOINT,
    { accesstoken: accessToken, params: myParams },
    { withCredentials: true },
  );
  return json.data;
}

export async function fetchEntitlements(accessToken) {
  const stickySessionId = await getOrCreateStickySessionId();
  const myParams = {
    "x-sticky-session-id": stickySessionId,
  };
  const json = await axios.post(
    BE_URL + EndpointsConstants.FETCH_ENTITLEMENTS_ENDPOINT,
    { accesstoken: accessToken },
    { withCredentials: true, params: myParams },
  );
  return json.data;
}
